export default {

    getErrorMessage(error) {
        if(error.non_field_errors) {
            if(error.non_field_errors.length>=1)
                return error.non_field_errors[0]
        }   
    }
}